import React, { useState, useEffect } from 'react';
import { Icon, Popup } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
import {
  getMarketScanPendingNotifications,
  getNotificationCount,
} from 'selectors';
import NotificationList from './NotificationList';
import styles from './styles/NotificationPopup.module.scss';
import { useLocation } from 'react-router-dom';
import {
  MARKET_SCAN_STATUS_ROUTE,
  NOTIFICATIONS_ROUTE,
} from 'constants/routes';
import { trackNotificationClick } from 'helpers';
import MobileNotification from './MobileNotification';

const MOBILE_SCREEN_BREAKPOINT = 820;

interface IProps {
  className?: string;
  onOpen?(): void;
  isMobile: boolean;
  popupClassName?: string;
}

const NotificationPopup = ({
  className,
  onOpen,
  isMobile,
  popupClassName,
}: IProps) => {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const count = useSelector(getNotificationCount);
  const msPendingNotifications = useSelector(getMarketScanPendingNotifications);
  const handleOpen = () => {
    trackNotificationClick();
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const isOpenStyle = location.pathname === NOTIFICATIONS_ROUTE || open;

  const hasNewNotifications = count > 0;

  const params = new URLSearchParams(location.search);
  const id = params.get('id');

  const screenWidth = window.innerWidth;

  useEffect(() => {
    const isCurrentScan = msPendingNotifications[0]?.target === id;

    if (
      location.pathname === MARKET_SCAN_STATUS_ROUTE &&
      msPendingNotifications.length > 0 &&
      !isCurrentScan &&
      ((screenWidth > MOBILE_SCREEN_BREAKPOINT && !isMobile) ||
        (screenWidth <= MOBILE_SCREEN_BREAKPOINT && isMobile))
    ) {
      setOpen(true);
    }
  }, [location, msPendingNotifications, id]);

  return (
    <>
      {isMobile && <MobileNotification />}

      <Popup
        style={{ zIndex: 998 }}
        className={classnames(
          open ? styles.popup : styles.newPopup,
          popupClassName,
        )}
        trigger={
          <div
            className={classnames(
              styles.trigger,
              className,
              open ? isOpenStyle && styles.open : styles.new,
            )}
            onClick={open ? () => {} : onOpen || handleOpen}
          >
            <Icon name="bell" />
            {!open && hasNewNotifications && <div className={styles.count} />}
          </div>
        }
        content={
          open ? (
            <NotificationList handleClose={handleClose} isMobile={isMobile} />
          ) : (
            'New notification'
          )
        }
        position={open ? 'bottom right' : 'left center'}
        onClose={open ? handleClose : () => {}}
        onOpen={open ? onOpen || handleOpen : () => {}}
        open={!open && hasNewNotifications && !isMobile ? true : open}
        on="click"
      />
    </>
  );
};

export default NotificationPopup;
